








import Vue from 'vue';
import CodeSection from '@/components/CodeSection.vue';
import {Route} from 'vue-router';
import Fetch from '@/lib/fetch';
import Selector from '@/components/Selector.vue';

export default Vue.extend({
    data() {
        return {
            codeBlocks: [],
        };
    },
    components: {
        CodeSection,
        Selector,
    },
    beforeRouteEnter(to: Route, from: Route, next: any) {
        next(async (vm: any) => vm.codeBlocks = await Fetch.get('/api/sandboxcontent'));
    },
});
